import SettingsPermissions from './SettingsPermissions';

export default SettingsPermissions;
